import { Fragment } from "react";
import { Listbox, Transition } from "@headlessui/react";
import ArrowIcon from "../Icons/ArrowIcon";
import CheckIcon from "../Icons/CheckIcon";
export interface option {
  id?: string;
  name: string;
  code?: string;
}

interface SelectboxProps {
  title?: string;
  name?: string;
  className?: string;
  selectOptions: option[];
  placeholder?: string;
  titleStyles?: string;
  setSelected?: React.Dispatch<React.SetStateAction<option | null>>;
  selected?: option | null;
  error?: string;
}

const CountriesSelectbox = ({
  title,
  className,
  selectOptions,
  name,
  placeholder,
  selected,
  setSelected,
  titleStyles,
  error,
}: SelectboxProps) => {
  const safeSelected =
    selected && typeof selected.name === "string" ? selected : null;
  return (
    <Listbox name={name} value={safeSelected} onChange={setSelected}>
      <div className="relative w-full">
        <h1 className={`text-slate text-lg font-semibold mb-3 ${titleStyles}`}>
          {title || ""}
        </h1>
        <Listbox.Button
          className={`relative text-left  text-xl block w-full py-2.5 focus:outline-none    hover:border-main_purple md:h-16 !h-[52px] px-4 text-slate border-2 border-black border-opacity-40 p-4 hover:border-primary hover:border-opacity-100 transition-all ease-in focus:border-secondary focus:ring-secondary/50 rounded-lg ${className}`}
        >
          <span className="block truncate text-base">
            {safeSelected ? safeSelected.name : placeholder || ""}
          </span>
          <span className="pointer-events-none absolute inset-y-0 right-2 flex items-center pr-2">
            <ArrowIcon className="w-6 h-4 rotate-[270deg]" />
          </span>
        </Listbox.Button>
        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm z-[9999]">
            {selectOptions.map((option, optionIdx) => (
              <Listbox.Option
                key={optionIdx}
                className={({ active }) =>
                  `relative cursor-default  select-none py-2 pl-10 pr-4 ${
                    active ? "bg-primary/50  text-white" : ""
                  }`
                }
                value={option}
              >
                {({ selected }) => (
                  <>
                    <span
                      className={`block text-sm truncate ${
                        selected ? "font-medium" : "font-normal"
                      }`}
                    >
                      {option.name}
                    </span>
                    {selected ? (
                      <span className="absolute inset-y-0 left-0 flex items-center  pl-3 text-amber-600">
                        <CheckIcon />
                      </span>
                    ) : null}
                  </>
                )}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
        {error && typeof error === "string" && (
          <span className={`text-red-500 sm:text-base text-xs `}>{error}</span>
        )}
      </div>
    </Listbox>
  );
};

export default CountriesSelectbox;
